import { render, staticRenderFns } from "./LabelTextField.vue?vue&type=template&id=4fe67a3f&scoped=true&"
import script from "./LabelTextField.vue?vue&type=script&lang=js&"
export * from "./LabelTextField.vue?vue&type=script&lang=js&"
import style0 from "./LabelTextField.vue?vue&type=style&index=0&id=4fe67a3f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe67a3f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
